// FEAT-C39: shared client gate for hiding confirmed+low internet coverage
// points on the admin mapping surfaces (address processing + activation
// processing), mirroring the monorepo MappedProvidersList. SHOW_MAPPING_CONFIDENCE
// is a runtime env var injected into client state (see makeInitialState `env`);
// surfaces read it with useBranch(['env', 'SHOW_MAPPING_CONFIDENCE']) and pass
// the value here. When off, every surface behaves exactly as before. Hidden
// rows stay in the browser so the reveal toggle can show them without re-fetching.
export const isShowMappingConfidenceEnabled = (value) => value === 'true';

export const isLowConfidenceProvider = (provider) =>
  provider?.coveragePoint?.confidenceStatus === 'confirmed' &&
  provider?.coveragePoint?.confidenceLevel === 'low';

// Given a provider list and whether confidence filtering is active + revealed,
// return the count of low-confidence providers and the list to display. Each
// surface decides `active` (flag + utility-type gate + role/partner-flag rules)
// and `showLowConfidence` (whether the viewer has revealed them); the count and
// filtering rule live here so they are not re-derived per component.
export const getLowConfidenceView = (providers, { active, showLowConfidence } = {}) => {
  const lowConfidenceCount = active ? providers.filter(isLowConfidenceProvider).length : 0;
  const displayedProviders =
    active && !showLowConfidence
      ? providers.filter((provider) => !isLowConfidenceProvider(provider))
      : providers;
  return { lowConfidenceCount, displayedProviders };
};

// Label for the reveal/hide toggle, shared so the pluralization stays identical.
export const lowConfidenceToggleLabel = (lowConfidenceCount, showLowConfidence) =>
  showLowConfidence
    ? 'Hide low-confidence providers'
    : `Show ${lowConfidenceCount} low-confidence provider${lowConfidenceCount === 1 ? '' : 's'}`;
